<script setup>
import DatePicker from 'vue-datepicker-next';

defineProps({
  placeholder: {
    type: String,
    default: '',
  },
});

const modelValue = defineModel({
  type: Date,
  default: null,
});
</script>

<template>
  <div class="date-picker small no-margin">
    <DatePicker
      v-model:value="modelValue"
      type="datetime"
      confirm
      :clearable="false"
      :editable="false"
      :placeholder="placeholder"
      input-class="mx-input"
    />
  </div>
</template>
